// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

//imports components
import styles from "../styles/profile.module.css";
import axios from "axios";
import { urlAPI_Current } from "../config";
import { Info } from "lucide-react";

export function UserPaymentsProfile({ darkMode }) {
  const [userData, setUserData] = useState([]);

  async function getPaymentsUser() {
    try {
      const responseSkills = await axios.post(`${urlAPI_Current}/getPaymentsUser`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
      });
      if(responseSkills.data.success == true) {
          const userInfo = responseSkills.data.user;
          setUserData(userInfo);

          console.log("Usuário possui dados");
      } else {
          console.log("Usuário não possui dados");
      }
  } catch (error) {
      console.log("Erro ao buscar dados")
  }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month}/${year} às ${hours}:${minutes}h`;
  };

  const hasValidPaidInvoices = userData?.some(user => {
    const paymentDate = new Date(user.dataPagamento);
    const cutoffDate = new Date('2024-08-30'); // Data de corte
    return user.pago && paymentDate >= cutoffDate;
  });

  useEffect(() => {
    getPaymentsUser();
  }, []); 

  return (
    <div className="card mb-5 mb-xl-10"  data-bs-theme={darkMode ? ('dark') : ('light')}>
      <div className="card-header d-flex justify-content-between align-items-start pt-8 pb-8">
        <div className="card-title">
          <h3>Histórico de Pagamentos</h3>
        </div>
     
        
        {hasValidPaidInvoices && (
          <div className="text-end">
            <p className="mb-0"><Info /> | Acesse o portal do cliente para configurar sua assinatura:</p>
            <a href="https://billing.stripe.com/p/login/dR602Af0kaLDfXq3cc" target="_blank" rel="noopener noreferrer">Portal do Cliente</a>
          </div>
        )}
    </div>

      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table align-middle table-row-bordered table-row-solid gy-4 gs-9">
            <thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
              <tr>
                <th className="min-w-150px">Data : Horário</th>
                <th className="min-w-100px">Plano</th>
                <th className="min-w-150px">Teste 7 dias</th>
                <th className="min-w-150px">Mes</th>
                <th className="min-w-150px">Preço</th>
                <th className="min-w-100px">Comprovante</th>
              </tr>
            </thead>

            <tbody className="fw-6 fw-semibold text-gray-600">
              {userData?.map((user, index) => (
                <tr key={index}>
                  <td>
                    <p className="text-hover-primary text-gray-600">
                      {formatDate(user.dataPagamento)}
                    </p>
                  </td>
                  <td>{user.plano == 1 ? "EVOK LITE" : user.plano == 2 ? "EVOK PERSONA" : user.plano}</td>
                  <td>
                    {user.teste7dias == 1 ? (<span className="badge badge-light-success fs-7 fw-bold">
                      SIM
                    </span>) : (<span className="badge badge-light-danger fs-7 fw-bold">
                      Não
                    </span>)}
                  </td>
                  <td>{user.mes}</td>
                  <td>{user.valor}</td>
                  {user.urlComprovante != null ? (<td><a href={user.urlComprovante} target="_blank">Abrir</a></td>) : (<td>Não possui</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
